// TODO refactor this

export default class AddressesMap {
	#map;

	#element;

	#placemarks;

	#placemarksCollection;

	#coords;

	constructor(selector) {
		this.#element = document.querySelector(selector);
		this.#placemarks = null;
		this.#placemarksCollection = null;
		this.#map = new Promise((resolve) => {
			ymaps.ready(async () => {
				resolve(
					new ymaps.Map(this.#element.id, {
						center: [55.76, 37.64],
						zoom: 12,
					})
				);
			});
		});
	}

	static #buildPlacemarks(coords) {
		return coords.map((coord) => AddressesMap.#makePlacemark(coord));
	}

	static #makePlacemark({ coords, location }) {
		const placemark = new ymaps.Placemark(
			coords,
			{
				balloonContent: location,
			},
			{
				iconLayout: 'default#image',
				iconImageHref: 'images/spot-ballon.png',
				iconImageSize: [38, 62],
			}
		);
		placemark.coord = coords;
		return placemark;
	}

	static findByCoords(targetCoords, collection) {
		return collection.find((object) => {
			const [targetX, targetY] = targetCoords;
			const [x, y] = object.coord;
			return x === targetX && y === targetY;
		});
	}

	get element() {
		return this.#element;
	}

	async #mountPlacemarks() {
		const collection = new ymaps.GeoObjectCollection();
		const p = [];
		this.#placemarks.forEach((placemark) => {
			p.push(collection.add(placemark));
		});
		await Promise.all(p);
		this.#placemarksCollection = collection;
		(await this.#map).geoObjects.add(collection);
	}

	async #getBeatifiedZoomAndCenter(object) {
		const bounds = object.getBounds();
		let beatifiedBounds;
		try {
			beatifiedBounds = await ymaps.util.requireCenterAndZoom(
				(await this.#map).getType(),
				bounds,
				(await this.#map).container.getSize()
			);
		} catch (error) {
			console.log('!!!!', error);
			return { center: [59.97272133453313, 30.26335249999996], zoom: 9 };
		}
		return { center: beatifiedBounds.center, zoom: beatifiedBounds.zoom };
	}

	async zoomToObject(target) {
		const { center, zoom } = await this.#getBeatifiedZoomAndCenter(target);
		(await this.#map).setCenter(center, 18);
	}

	async zoomToObjectOnInit(target) {
		const { center, zoom } = await this.#getBeatifiedZoomAndCenter(target);
		(await this.#map).setCenter(center, 10);
	}

	initPlacemarks(coords) {
		return new Promise((resolve) => {
			ymaps.ready(async () => {
				await this.#map;
				this.#coords = coords;

				this.#placemarks = AddressesMap.#buildPlacemarks(coords);
				await this.#mountPlacemarks();
				await this.zoomToPlacemarks();
				resolve();
			});
		});
	}

	zoomToPlacemarks() {
		return this.zoomToObject(this.#placemarksCollection);
	}

	zoomToPlacemarksOnInit() {
		return this.zoomToObjectOnInit(this.#placemarksCollection);
	}

	async open(coord) {
		const targetPlacemark = AddressesMap.findByCoords(coord, this.#placemarks);
		await targetPlacemark.balloon.open();
		await this.clickToZoom();
		(await this.#map).setCenter(coord, 18);
	}

	onPlacemarkClick(cb) {
		const handleClick = (ev) => {
			const placemarkCoords = ev.originalEvent.target.coord;
			const placemark = this.#coords.find(({ coords }) => {
				const [targetX, targetY] = placemarkCoords;
				const [x, y] = coords;
				return x === targetX && y === targetY;
			});
			cb(placemark);
		};

		ymaps.ready(() => {
			this.#placemarks.forEach((placemark) => {
				placemark.events.add('click', handleClick);
			});
		});
	}

	clickToZoom() {
		ymaps.ready(() => {
			this.#placemarks.forEach((placemark) => {
				placemark.events.add('click', () => {
					this.#map.then((map) => {
						map.setZoom(18);
					});
				});
			});
		});
	}
}
